import { Container, Row, Col } from 'react-bootstrap';
import { FaLinkedin, FaFacebook, FaYoutube } from 'react-icons/fa';
import logo from '../assests/logo.png';
import './Footer.css';

const FOOTER_COLS = [
  {
    title: 'About Us',
    links: [
      { label: 'Company Overview', href: '/aboutus' },
      { label: 'Vision & Mission', href: '/aboutus' },
      { label: 'Core Values', href: '/aboutus' },
    ],
  },
  {
    title: 'Our Products',
    links: [
      { label: 'Automotive Body Graphics', href: '/products' },
      { label: 'Domed Labels', href: '/products' },
      { label: 'Helmet Decals', href: '/products' },
      { label: 'Self-Adhesive Labels', href: '/products' },
      { label: 'Vehicle Wrap Films', href: '/products' },
    ],
  },
  {
    title: 'Our Capabilities',
    links: [
      { label: 'Graphic Designing', href: '/capabilities' },
      { label: 'Manufacturing', href: '/capabilities' },
      { label: 'Quality Control Laboratory', href: '/capabilities' },
    ],
  },
];

const SOCIAL_LINKS = [
  { Icon: FaLinkedin, href: '#', label: 'LinkedIn', className: 'social-linkedin' },
  { Icon: FaFacebook, href: '#', label: 'Facebook', className: 'social-facebook' },
  { Icon: FaYoutube, href: '#', label: 'YouTube', className: 'social-youtube' },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-accent-bar" />

      <Container>
        <Row className="footer-main g-4 g-lg-5">
          <Col lg={3} md={6} className="footer-brand-col">
            <a href="/" className="footer-logo-link">
              <img src={logo} alt="Decal Tech" className="footer-logo" />
            </a>
            <p className="footer-tagline">
              Premium labels, graphics &amp; decals — engineered for durability since 2017.
            </p>
          </Col>

          {FOOTER_COLS.map((col) => (
            <Col lg={2} md={6} key={col.title} className="footer-col">
              <h4 className="footer-heading">{col.title}</h4>
              <ul className="footer-links">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="footer-link">{link.label}</a>
                  </li>
                ))}
              </ul>
            </Col>
          ))}

          <Col lg={3} md={6} className="footer-col">
            <h4 className="footer-heading">Contact Us</h4>
            <div className="footer-contact">
              <p className="footer-company">Decal Tech Private Limited</p>
              <address className="footer-address">
                Unit no. G1-A, Rajlaxmi Hi Tech Park
                <br />
                Mumbai - Nashik Highway, Sonale
                <br />
                Bhiwandi, Thane - 421302
              </address>
              <p className="footer-email">
                <a href="mailto:info@decaltech.in">info@decaltech.in</a>
              </p>
            </div>
            <div className="social-icons">
              {SOCIAL_LINKS.map(({ Icon, href, label, className }) => (
                <a
                  key={label}
                  href={href}
                  className={`social-icon-btn ${className}`}
                  aria-label={label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon />
                </a>
              ))}
            </div>
          </Col>
        </Row>

        <div className="footer-bottom">
          <p className="copyright">
            © {new Date().getFullYear()} Decal Tech. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
